export default "__VITE_ASSET__D_yvHHt9__"